<h1 mat-dialog-title>Unschedule</h1>
<div mat-dialog-content>
  Are you sure you want to unschedule this action(s)?
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog color="primary" (click)="handleCancel()">
    Cancel
  </button>
  <button
    mat-button
    mat-dialog
    color="warn"
    cdkFocusInitial
    (click)="handleConfirm()">
    Confirm
  </button>
</div>
